module.exports = ".set-scale-modal {\n  padding: 10px; }\n  .set-scale-modal h2 {\n    text-align: center;\n    margin: 0 0 10px 0;\n    font-size: 25px; }\n  .set-scale-modal button {\n    display: block; }\n  .set-scale-modal .mat-form-field label {\n    white-space: nowrap; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/services/proTools/ng-components/set-scale-modal/set-scale-modal.component.scss
// module id = ./src/app/services/proTools/ng-components/set-scale-modal/set-scale-modal.component.scss
// module chunks = main